module.exports = __webpack_public_path__ + "media/svg-new/logoMini2-bdee1f92.svg";